module.exports = __webpack_public_path__ + "static/media/mt-icone-encart-6.ea5bbdb9.svg";